import { render } from "./App.vue?vue&type=template&id=26d85e44&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=26d85e44&scoped=true&lang=css"

import exportComponent from "/vercel/path0/vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d85e44"]])

export default __exports__